import Registry from "../registry";
import React from "react";

const number = {
  name: "Number",
  group: "Basic",
  options: {
    min: {
      label: "Minimum Value",
      type: "number"
    },
    max: {
      label: "Maximum Value",
      type: "number"
    }
  },
  schema: part => ({
    type: "number",
    component: ({ value, onChange }) => (
      <input
        type="number"
        className="form-control"
        value={value}
        min={part.min}
        max={part.max}
        onChange={e => onChange(e.target.value)}
      />
    ),
    validate: (field, value) => {
      if (part.min && value < part.min) {
        throw new Error(`Value must be greater than ${part.min}`);
      }
      if (part.max && value > part.max) {
        throw new Error(`Value must be less than ${part.max}`);
      }
      return true;
    }
  })
};

Registry.register("number", number);
export default number;



// WEBPACK FOOTER //
// ./app/parts/number.js